export default __webpack_public_path__ + "static/media/reading.fe8686dd.png";